import { render, staticRenderFns } from "./footBallNumToYouthStatistics.vue?vue&type=template&id=f96b6bfc&scoped=true&"
import script from "./footBallNumToYouthStatistics.vue?vue&type=script&lang=js&"
export * from "./footBallNumToYouthStatistics.vue?vue&type=script&lang=js&"
import style0 from "./footBallNumToYouthStatistics.vue?vue&type=style&index=0&id=f96b6bfc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96b6bfc",
  null
  
)

export default component.exports